import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zeznbkk8a: FaireProductEntity = {
  token: "p_6zeznbkk8a",
  type: "product",
  name: "Small Easter Geese Bucket",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/2bde850cec753426e3ff27e1db077e150788c7a2958c4b01f802c02b2f56f814.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/292d14c4d297d2bf1a8bcec2dc5a740f48752e8a9b30d7c1a1b39dfae5724ce1.jpeg",
    "https://cdn.faire.com/fastly/80b86659ce69061188d3205d2f21f648c7c760c2824f6732b490a14ff9bd80d6.jpeg",
    "https://cdn.faire.com/fastly/06e006929a567abb74cb7ea1df1075f9dd1ad5683c250bb9d65196173e15184b.jpeg",
    "https://cdn.faire.com/fastly/f06f8dff59ac34db71ed5809d11a2f7cc10acea05140b9384170e1b879bdfdb8.jpeg"
  ],
  priceDollars: 10.5,
  description: "A small metal bucket from our Easter & Spring Collection featuring a full wrap-around design of cute goose characters dressed for Easter fun. Easter geese bucket is perfect for displaying spring greenery, creating premium Easter baskets, or a fun accessory for Easter egg hunts. Greenery and accessories pictured not included. Our small Easter Geese bucket includes a metal handle with a wooden grip for easy carrying. A cute goose-themed Easter accessory with a variety of seasonal display options.",
  tags: [],
  msrpDollars: 20.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:26.998Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
